var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary mt-2 text-white",attrs:{"disabled":_vm.checked === false ||
      _vm.tipoCDP == 0 ||
      (_vm.tipoCDP == 2 && (_vm.ruc.length != 11 || _vm.razsoc == '' || _vm.facdir == ''))},on:{"click":function($event){return _vm.clickToPayWithNiubiz()}}},[_vm._v("\n  Pasar a pagar con tarjeta(Niubiz)\n")])}
var staticRenderFns = []

export { render, staticRenderFns }